var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fapi-form-basic-block"},[_c('div',{staticClass:"f-px-2 f-py-3 f-flex f-font-semibold f-relative f-justify-between f-items-center fapi-container-header",class:{
      'order-bump f-py-2': _vm.orderBump,
    }},[_c('div',{staticClass:"fapi-form-basic-block-title f-w-full f-text-center",class:{
        'order-bump-title': _vm.orderBump,
      }},[(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"fapi-form-basic-block-title-after f-absolute f-right-0"},[_vm._t("titleAfter")],2)]),_c('div',{staticClass:"f-p-6",class:{ 'order-bump-content': _vm.orderBump }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }